<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card/index";

interface Props {
  title: string;
  description?: string;
  titleClass?: string;
}

withDefaults(defineProps<Props>(), {
  description: "",
  titleClass: "text-xl tracking-tight sm:text-2xl",
});
</script>

<template>
  <main class="page-container-sm page-section flex min-h-[calc(100dvh-3.5rem)] items-center">
    <Card class="card-surface w-full">
      <CardHeader>
        <CardTitle :class="titleClass">{{ title }}</CardTitle>
        <p v-if="description" class="mt-1 text-sm text-muted-foreground">
          {{ description }}
        </p>
      </CardHeader>

      <CardContent>
        <slot />
      </CardContent>
    </Card>
  </main>
</template>
